import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody } from "reactstrap";

import { formatMoneyFromCents } from "../../../helpers/money";

type Props = {
  estimatedCents: number;
  paidCents: number;
  loading?: boolean;
};

const DashboardDayEstimateCard = ({
  estimatedCents,
  paidCents,
  loading = false,
}: Props) => {
  const { t, i18n } = useTranslation();

  return (
    <Card className="border-0 shadow-sm h-100 mb-0 rounded-3">
      <CardBody className="p-4">
        <h5 className="mb-3 fw-semibold">{t("studio.dashboard.dayEstimate.title")}</h5>
        {loading ? (
          <p className="text-muted mb-0">{t("studio.dashboard.loading")}</p>
        ) : (
          <>
            <div className="mb-3">
              <h2 className="mb-1 fw-semibold lh-sm" style={{ letterSpacing: "-0.02em" }}>
                {formatMoneyFromCents(estimatedCents, i18n.language)}
              </h2>
              <p className="text-muted small mb-0">
                {t("studio.dashboard.dayEstimate.estimatedHint")}
              </p>
            </div>
            <hr className="my-3 text-muted opacity-25" />
            <div>
              <p className="text-muted small mb-1">
                {t("studio.dashboard.dayEstimate.paidLabel")}
              </p>
              <h4 className="mb-1 fw-semibold">
                {formatMoneyFromCents(paidCents, i18n.language)}
              </h4>
              <p className="text-muted small mb-0">
                {t("studio.dashboard.dayEstimate.paidHint")}
              </p>
            </div>
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default DashboardDayEstimateCard;
